module.exports = __webpack_public_path__ + "img/a.390ceccf.jpg";